export default __webpack_public_path__ + "static/media/IMG2.a231b9ae.JPG";